import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import { initConfig } from '../config.js';
import './assets/styles/main.scss';

let app = null;

async function bootstrapApp() {
    const config = await initConfig();
    const { default: App } = await import('./App.vue');
    const { default: router } = await import('@/helpers/router');
    const { default: i18n} = await import('./i18n');
    const { useUserStore } = await import('@/store/index');
    const { registerAuthInterceptor } = await import('./services/api');

    app = createApp(App);

    const pinia = createPinia();
    const head = createHead();

    app.config.globalProperties.$config = config;

    let browserLanguage = localStorage.getItem('lang');

    if (!browserLanguage) {
        browserLanguage = navigator.language || navigator.userLanguage;
        //get the first two characters of the language
        browserLanguage = browserLanguage.split(/[-_]/)[0]; 
        localStorage.setItem('lang', browserLanguage);
    } else {
        //add the language code
        browserLanguage = browserLanguage.split(/[-_]/)[0]; 
    }

    i18n.global.locale = browserLanguage;
    console.log(browserLanguage);

    app.config.globalProperties.$browserLanguage = browserLanguage;

    app.use(i18n);
    app.use(router);
    app.use(head);
    app.use(pinia);

    const userStore = useUserStore();
    registerAuthInterceptor(userStore);

    app.provide('config', config);
    app.mount('#app');
}

bootstrapApp();
